import { render, staticRenderFns } from "./Subsubcategoria.vue?vue&type=template&id=b5956696&scoped=true"
import script from "./Subsubcategoria.vue?vue&type=script&lang=js"
export * from "./Subsubcategoria.vue?vue&type=script&lang=js"
import style0 from "./Subsubcategoria.vue?vue&type=style&index=0&id=b5956696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5956696",
  null
  
)

export default component.exports